<template>
  <div>
    <div class="mt-15 container card_container">
      <div class="mb-5 titolo">
        <h3 class="text-white mt-5 text-center"><i class="fas fa-clipboard-list"></i> Lista Sedi</h3>
      </div>
      <b-container class="bv-example-row">
        <b-card bg-variant="light">
          <b-container class="bv-example-row pt-lg-6">
            <b-row>
              <b-col sm class="mb-7">
                <span class="text-primary">Codice fiscale</span><br />
                <span>{{ assistito.codiceFiscale }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Assistito</span><br />
                <span>{{ assistito.nome }} {{ assistito.cognome }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Data di nascita</span><br />
                <span>{{ assistito.dataNascita }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-container>
    </div>
    <div class="my-5 container card_container">
      <b-table
        striped
        hover
        :items="listaStrutture"
        :current-page="currentPage"
        :per-page="perPage"
        responsive
        stacked="lg"
        :fields="fieldStruttura"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
        ><template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <div class="divcheck">
              <span aria-hidden="true">&check;</span>
            </div>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template></b-table
      >
      <template>
        <b-row>
          <b-col cols="6">
            <strong class="text-primary"> Sono presenti {{ rows }} strutture</strong>
          </b-col>
          <b-col cols="6">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </template>
      <b-container class="bv-example-row">
        <b-row>
          <b-col
            ><b-button variant="my-5 btn-outline" class="mb-5" @click="onIndietro"> <i class="fas fa-angle-double-left"></i> Indietro </b-button></b-col
          >
          <b-col></b-col>
          <b-col
            ><b-button variant="my-5 btn-outline" :disabled="disabilitaAvanti" class="mb-5 ml-21" @click="onAvanti"> <i class="fas fa-chevron-right"></i> Avanti </b-button></b-col
          >
        </b-row>
      </b-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  props: {
    assistito: Object,
    prestazioneSelezionata: Object,
    zona: String,
    listaStrutture: Array,
  },
  components: { Loading },
  data() {
    return {
      pathResourceSediAlpi: "/api/v2.0/appecupt/aslengi/alpi/unitaOperative",
      tokenLogin: null,
      isLoading: false,
      currentPage: 1,
      perPage: 5,
      fieldStruttura: [
        {
          label: "Codice Unita",
          key: "idUnita",
          sortable: true,
        },
        {
          label: "Descrizione Unita",
          key: "descrizioneUnita",
        },
        {
          label: "Selezionato",
          key: "selected",
          thStyle: "width: 6rem",
        },
      ],
      strutturaSelezionata: null,
      disabilitaAvanti: true,
    };
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
  },
  computed: {
    rows() {
      return this.listaStrutture.length;
    },
  },
  methods: {
    onRowSelected(item) {
      let me = this;
      me.strutturaSelezionata = item;
    },
    onIndietro() {
      let me = this;
      me.$emit("setStep", 0);
    },
    onAvanti() {
      let me = this;
      me.$emit("getPrestazioneSelezionata", me.prestazioneSelezionata);
      me.$emit("getStrutturaSelezionata", me.strutturaSelezionata);
      me.$emit("setStep", 2);
    },
  },
  watch: {
    strutturaSelezionata: function (data) {
      let me = this;
      if (data !== undefined) {
        me.disabilitaAvanti = false;
      } else {
        me.disabilitaAvanti = true;
      }
    },
  },
};
</script>
